export const TEMPLATES_TYPES = {
  CUSTOM: 'custom',
  SYSTEM: 'system',
  WELCOME_MESSAGE: 'welcomeMessage',
  FILE: 'file',
  SYSTEM_FILE: 'systemFile'
}
